import React, { memo, useEffect, useMemo, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { useBoard } from "../hooks/useBoard";
import { useHints } from "../hooks/useHints";
import { CrossoutsAtom, HistoryStepNumberAtom } from "../utils/context";
import { cssClasses } from "../utils/cssClasses";
import { generateCrossoutFor } from "../utils/hints";
function LineHintNumbers(_a) {
    var line = _a.line, goalHints = _a.goalHints, id = _a.id;
    var setCrossoutsAtom = useSetRecoilState(CrossoutsAtom);
    var _b = useState({
        completed: false,
        overflow: false,
        line: goalHints.map(function (hint) { return ({
            crossout: false,
            hint: hint
        }); })
    }), crossout = _b[0], setCrossout = _b[1];
    // TODO: use a worker to delegate the computing of hints?
    useEffect(function () {
        setTimeout(function () {
            setCrossout(generateCrossoutFor(line, goalHints));
        }, Math.random() * 100);
    }, [line, goalHints]);
    useEffect(function () {
        setCrossoutsAtom(function (crossoutMap) {
            var newCrossoutMap = new Map(crossoutMap);
            newCrossoutMap.set(id, crossout);
            return newCrossoutMap;
        });
    }, [crossout, id]);
    return (React.createElement("div", { className: cssClasses("hint-group", crossout.overflow && crossout.completed && "overflow") },
        React.createElement("div", { className: cssClasses("inner-hint-group") }, crossout.line.map(function (co, i) { return (React.createElement("div", { key: i, className: cssClasses("hint", co.crossout && "crossout") }, co.hint)); }))));
}
var MemoLineHintNumbers = memo(LineHintNumbers, function (prev, next) {
    return (prev.line.join("") === next.line.join("") &&
        prev.goalHints.join("") === next.goalHints.join(""));
});
/**
 * Translates either row or column hint numbers into HTML div elements.
 *
 * The current hint numbers according to the current state of the board
 * are compared to the static goal hint numbers in order to "cross out"
 * some numbers in order to assist the user in figuring out what sequences
 * they've already finished.
 *
 * Crossed out hint numbers appear as a different color than normal hint numbers,
 * and are thus given a different div className than normal hint numbers.
 *
 */
export function HintNumbers(_a) {
    var lineType = _a.lineType;
    var getLine = useBoard().getLine;
    var goalHints = useHints().goalHints;
    var stepNumber = useRecoilValue(HistoryStepNumberAtom);
    var goalHintsLines = useMemo(function () {
        return lineType === "row" ? goalHints.rows : goalHints.cols;
    }, [lineType, goalHints]);
    var hintGroups = useMemo(function () {
        return goalHintsLines.map(function (hintLine, i) { return (React.createElement(MemoLineHintNumbers, { key: i, id: lineType + i, goalHints: hintLine, line: getLine(lineType, i) })); });
    }, [stepNumber, goalHintsLines, getLine]);
    return (React.createElement("div", { className: cssClasses("hint-groups", lineType === "col" ? "col-hint-groups" : "row-hint-groups") }, hintGroups));
}
